export function initFilterCase() {
  const filter = document.querySelector('.case-filter');
  if (!filter) return;

  const toggle = filter.querySelector('.case-filter__toggle');

  toggle.addEventListener('click', () => {
    filter.classList.toggle('is-open');
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!filter.contains(e.target)) {
      filter.classList.remove('is-open');
    }
  });

  window.filterCase = function(id, btn) {
    const items = document.querySelectorAll('.case-item');
    const buttons = document.querySelectorAll('.case-filter__option');

    // Update buttons active state
    buttons.forEach(b => b.classList.remove('is-active'));
    if (btn) {
        btn.classList.add('is-active');
    } else {
        // If called without btn (e.g. init or Alle), find the 'Alle' button
        const allBtn = Array.from(buttons).find(b => b.dataset.id === 'null' || !b.dataset.id);
        if (allBtn) allBtn.classList.add('is-active');
    }

    if (!id) {
      items.forEach(item => item.classList.remove('hidden'));
    } else {
      items.forEach(item => {
        if (item.classList.contains(`case-${id}`)) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    }

    filter.classList.remove('is-open');
  }
}

